import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { APP_NAME } from '@/shared/lib/constants'

export function TermsPage() {
  return (
    <div className="min-h-screen bg-legal-50 dark:bg-legal-900 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-legal-600 dark:text-legal-400 hover:text-legal-800 dark:hover:text-legal-300 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>

        <article className="bg-white dark:bg-legal-800 rounded-xl shadow-md p-8">
          <h1 className="text-3xl font-bold text-legal-900 dark:text-white mb-6">
            Términos y Condiciones de Uso
          </h1>

          <p className="text-sm text-legal-600 dark:text-legal-400 mb-8">
            Última actualización: 11 de noviembre de 2025
          </p>

          <div className="space-y-6 text-legal-700 dark:text-legal-300">
            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                1. Aceptación de los Términos
              </h2>
              <p>
                Al acceder y utilizar {APP_NAME}, aceptás estar sujeto a estos Términos y Condiciones de Uso.
                Si no estás de acuerdo con alguno de estos términos, no utilices esta herramienta.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                2. Naturaleza del Servicio
              </h2>
              <p className="mb-3">
                {APP_NAME} es una herramienta técnica de verificación de firmas digitales y electrónicas en documentos PDF,
                diseñada para asistir en la gestión de evidencia digital en procesos judiciales argentinos.
              </p>
              <p className="font-semibold text-legal-900 dark:text-white">
                IMPORTANTE: {APP_NAME} NO constituye asesoramiento legal. Los resultados de la verificación son de naturaleza
                técnica y deben ser interpretados por profesionales del derecho en el contexto de cada caso específico.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                3. Privacidad y Procesamiento de Documentos
              </h2>
              <div className="bg-legal-50 dark:bg-legal-900 border-l-4 border-legal-600 p-4 mb-3">
                <p className="font-semibold mb-2">Compromiso de Privacidad:</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>NO guardamos ningún documento evaluado</li>
                  <li>NO almacenamos información de los PDFs procesados</li>
                  <li>Todo el procesamiento se realiza en memoria</li>
                  <li>Los documentos NO se guardan en ningún servidor</li>
                  <li>Los archivos se eliminan de memoria inmediatamente después del análisis</li>
                </ul>
              </div>
              <p>
                El hash SHA-256 del documento se calcula localmente en tu navegador antes de enviarlo al servidor,
                garantizando que el archivo original no es alterado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                4. Uso Permitido
              </h2>
              <p className="mb-2">Podés utilizar {APP_NAME} para:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Verificar la autenticidad de firmas digitales en PDFs</li>
                <li>Obtener constancias técnicas de verificación</li>
                <li>Analizar el valor probatorio de documentos firmados</li>
                <li>Gestión de evidencia digital en procesos judiciales</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                5. Limitaciones y Exclusiones de Responsabilidad
              </h2>
              <p className="mb-2">
                {APP_NAME} proporciona una herramienta técnica de análisis. No garantizamos:
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Que la herramienta esté libre de errores o interrupciones</li>
                <li>La validez legal de los documentos verificados</li>
                <li>Resultados específicos en procesos judiciales</li>
                <li>Compatibilidad con todos los tipos de certificados digitales</li>
              </ul>
              <p className="mt-3 font-semibold">
                El usuario es responsable de verificar la aplicabilidad de los resultados a su caso específico
                con asesoramiento legal profesional.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                6. Marco Legal Aplicable
              </h2>
              <p>
                {APP_NAME} opera bajo el marco legal de la República Argentina, específicamente la Ley 25.506 de Firma Digital
                y normativa complementaria. Los análisis se realizan según estándares argentinos de infraestructura de clave pública (PKI).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                7. Modificaciones a los Términos
              </h2>
              <p>
                Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor
                inmediatamente después de su publicación en esta página. Es responsabilidad del usuario revisar periódicamente
                estos términos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-legal-900 dark:text-white mb-3">
                8. Contacto
              </h2>
              <p>
                Para consultas sobre estos términos o sobre el funcionamiento de {APP_NAME}, contactá a través de{' '}
                <a
                  href="https://arteclaw.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-legal-600 dark:text-legal-400 hover:text-legal-800 dark:hover:text-legal-300 underline"
                >
                  Arteclaw
                </a>.
              </p>
            </section>
          </div>
        </article>
      </div>
    </div>
  )
}
